import { BaseColour, Tag, TagType } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface TagResponse {
    id: number
    created_at: string
    updated_at: string
    name: string
    type: TagType
    colour: BaseColour
    is_available_for_merchants: boolean
}

export function toTag(t: TagResponse): Tag {
    return {
        id: t.id,
        createdAt: t.created_at,
        updatedAt: t.updated_at,
        name: t.name,
        type: t.type,
        colour: t.colour,
        isAvailableForMerchants: t.is_available_for_merchants,
    };
}

export interface createTagFormInterface {
    name: string
    colour: BaseColour
    type: TagType
    isAvailableForMerchants: boolean
}

export interface editTagFormInterface {
    name: string
    colour: BaseColour
    isAvailableForMerchants: boolean
}

interface TagsApiReturn {
    fetchTags: (type?: TagType) => Promise<Tag[]>
    deleteTag: (tagId: number) => Promise<void>
    createTag: (data: createTagFormInterface) => Promise<Tag>
    editTag: (tagId: number, data: editTagFormInterface) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): TagsApiReturn => ({
    fetchTags: async (type?: TagType): Promise<Tag[]> => {
        const url = new URL('/api/tags', location.origin);
        if (type != null) {
            url.searchParams.append('type', type);
        }

        const response = await axios.get<{ data: Tag[] }>(url.toString());

        return response.data.data;
    },

    deleteTag: async (tagId: number): Promise<void> => {
        return axios.delete(`/api/tags/${tagId}`);
    },

    createTag: async (data: createTagFormInterface): Promise<Tag> => {
        const response = await axios.post<{ data: TagResponse }>('/api/tags', { name: data.name, colour: data.colour, type: data.type, isAvailableForMerchants: data.isAvailableForMerchants });

        return toTag(response.data.data);
    },

    editTag: async (tagId: number, data: editTagFormInterface): Promise<void> => {
        await axios.put(`/api/tags/${tagId}`, { name: data.name, colour: data.colour, isAvailableForMerchants: data.isAvailableForMerchants });
    },
});
